import { DataTableSchema } from "./dynamic-data-table.model";
import { FieldNames } from "./form-fields.model";
import { SectionType } from "./form.model";

export const FETCH_METHODS = {
    Post: 'POST',
    Get: 'Get'
} as const

export const API_STATUS = {
    Success: 'success',
    Error: 'error'
} as const;

export const STATUS_CODE_MSG = {
    "0": "No Response Found",
    "200": "OK",
    "301": "Moved Permanently",
    "400": "Bad Request",
    "401": "Unauthorized",
    "403": "Forbidden",
    "404": "Not Found",
    "500": "Internal Server Error",
    "default": "Error Fetching Data"
} as const;

export const ERROR_RESPONSE = {
    searchConfigMissing: 'Api payload missing',
    noDataToDownload: 'No Data Available To Download',
    noDataFound: 'No Data Found',
    someErrorOccured:'Some error occured',
    errorFetch:'Some error occured, Please try again after sometime',
    logoutMsg:'Are you sure, you want to logout?',
    layoutErrorPrefix: 'Layout Error:- ',
    tokenMissing: 'Token Expired, Re-login Again',
    tokenExpired:'Token Expired, Do you want to relogin?'
}

export const fieldOptionsSearchConfig: Record<string, SearchConfig> = {
    [FieldNames['JobRole']]: {
        method: FETCH_METHODS['Get'],
        path: "jobCodes"
    },
    [FieldNames['Event']]: {
        method: FETCH_METHODS['Get'],
        path: "jobRolesAndEvents"
    },
    [FieldNames['DealerNumber']]: {
        method: FETCH_METHODS['Get'],
        path: "billingReportDealersList"
    },
    [FieldNames['CourseShortName']]: {
        method: FETCH_METHODS['Get'],
        path: "billingReportCoursesList"
    },
    [FieldNames['CourseNameCode']]: {
        method: FETCH_METHODS['Get'],
        path: "billingReportCoursesList"
    }
}

export interface TableConfig {
    schema: DataTableSchema,
    dataInput: Array<any>
}
export interface FetchParams {
    searchConfig: SearchConfig,
    type: SectionType
}

export interface SearchConfig {
    method: FetchMethod,
    path: string,
    body?: any,
    getBaseUrl?: any,
    urlPath?: string,
    headers?:any
}
export interface ExportConfig {
  tableSchema?: DataTableSchema; 
  environment: string;
  fileExtension: string;
  searchParameters: SearchConfig;
  exportFileName: string;
}

export interface ApiPayload {
    url: string,
    body?: any,
    method: FetchMethod,
    headers?: any,
    type?: any
}

export interface ApiResponse {
    status: ApiStatus,
    result: Array<any>,
    errorMsg?: string
}

export type ApiStatus = typeof API_STATUS[keyof typeof API_STATUS];

export type FetchMethod = typeof FETCH_METHODS[keyof typeof FETCH_METHODS];

export const ApiEnvNames:Record<string, string> = {
    JobEnrollment: "jobEnrollment",
    StaffMaster: "staffMaster",
    ElevateBilling:"elevateBilling",
    EventBilling:"eventBilling",
    DealerTrainingBilling:"dealerTrainingBilling",
    TurnOverReport:'turnOverReport',
    AseReport:'aseReport',
    UserAccess: 'UserAccess',
    Tenure:'tenure',
    ChatBot:'chatbot',
    EliteCertification: 'eliteCertification',
    EventDashboard: 'eventDashboard',
    ImpactAnalysis: 'impactAnalysis',
    GoogleAnalytics: 'googleAnalytics',
    DealerScorecard: 'dealerScorecard'

}